import React from 'react'
// @ts-ignore no types
import { Text, constants } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import { PATH_CONFIG, type PurchasePath } from 'common/utils/listingPaths'
import PathOptionButton from '../pathOptionButton'
// @ts-ignore no types
import cls from './styles.scss'

const cx = classnames.bind(cls)
const { ColorNames } = constants

export interface PathOptionListProps {
  paths: PurchasePath[]
  elmIdPrefix: string
  onSelect: (path: PurchasePath) => void
  selectedListingId?: string
  variant?: 'default' | 'modal'
}

const PathOptionList = ({
  paths,
  elmIdPrefix,
  onSelect,
  selectedListingId,
  variant = 'default',
}: PathOptionListProps) => (
  <>
    {paths.map((path, i) => (
      <React.Fragment key={path.type}>
        {i > 0 && (
          <div className={cx('divider')}>
            <span className={cx('divider-line')} />
            <Text
              as='span'
              size={variant === 'modal' ? 'small' : 'tiny'}
              weight='heavy'
              color={ColorNames.Gray}
              style={{ letterSpacing: '0.98px' }}
            >
              OR
            </Text>
            <span className={cx('divider-line')} />
          </div>
        )}
        <PathOptionButton
          selected={
            selectedListingId != null &&
            path.listing.listing_id === selectedListingId
          }
          title={PATH_CONFIG[path.type].title}
          subtitle={PATH_CONFIG[path.type].subtitle}
          iconName={PATH_CONFIG[path.type].iconName}
          color={PATH_CONFIG[path.type].color}
          variant={variant}
          onClick={() => onSelect(path)}
          elmId={`${elmIdPrefix}_${PATH_CONFIG[path.type].elmId}`}
        />
      </React.Fragment>
    ))}
  </>
)

export default PathOptionList
